import { httpApps } from "../helper/http-common";

class ChooseSettingServices {
  PendantBuilderLoadStud(inputData) {
    return httpApps.post("PendantBuilderForML/PendantBuilderLoadStud", inputData);
  }
}

export default new ChooseSettingServices();
